<template>
	<div class="main-intro">
		<img class="bg" :src="bgImg" />
		<div class="contents">
			<div class="p1">
				<div class="p2">
					<p class="text1">
						<span class="t1">새로운 자동차 관리의 시작</span>
						<br />
						<span class="t2">내 손안의 차량관리 ‘<span>카랑</span>’</span>
						<br />
					</p>
					<p class="text2">
						VISITION & CULTURE<br />
						자동차 애프터마켓 플랫폼<br />
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			isMobile: false,
			bgImg: 'static/img/intro-content/site_company_main.png',
		}
	},
	mounted() {
		window.addEventListener('resize', this.resize)
		this.resize()
	},
	methods: {
		resize() {
			if (window.innerWidth > 640) {
				this.bgImg = 'static/img/intro-content/site_company_main.png'
				this.isMobile = false
			} else {
				this.bgImg = 'static/img/mobile/intro-content/site_company_main_m.png'
				this.isMobile = true
			}
		},
	},
}
</script>

<style scoped>
.main-intro {
	width: 100%;
	position: relative;
}
.main-intro .bg {
	width: 100%;
	height: auto;
	display: block;
}
/* pc */
@media (max-width: 1280px) {
	.text1 .t1 {
		font-style: normal;
		font-weight: 300;
		font-size: 32px;
		line-height: 48px;
		color: #000000;
	}
	.text1 .t2 {
		font-style: normal;
		font-weight: bold;
		font-size: 32px;
		line-height: 48px;
		color: #000000;
	}
	.text1 .t2 span {
		font-style: normal;
		font-weight: bold;
		font-size: 32px;
		line-height: 48px;
		color: #000000;
		background: linear-gradient(to top, #007def 10%, transparent 10%);
	}
	.text2 {
		font-style: normal;
		font-weight: 300;
		font-size: 16px;
		line-height: 23px;
		color: #444444;
	}
}
@media (min-width: 1280px) {
	.text1 .t1 {
		font-style: normal;
		font-weight: 300;
		font-size: 2.5vw;
		line-height: 3.7vw;
		color: #000000;
	}
	.text1 .t2 {
		font-style: normal;
		font-weight: bold;
		font-size: 2.5vw;
		line-height: 3.7vw;
		color: #000000;
	}
	.text1 .t2 span {
		font-style: normal;
		font-weight: bold;
		font-size: 2.5vw;
		line-height: 3.7vw;
		color: #000000;
		background: linear-gradient(to top, #007def 10%, transparent 10%);
	}
	.text2 {
		font-style: normal;
		font-weight: 300;
		font-size: 1.25vw;
		line-height: 1.8vw;
		color: #444444;
	}
}
@media (min-width: 641px) {
	.main-intro .contents {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		width: 50%;
		height: 100%;
	}
	.main-intro .p1 {
		position: relative;
		display: flex;
		align-items: center;
		height: 100%;
	}
	.main-intro .p2 {
		position: absolute;
		right: 0;
		margin-right: 8%;
	}
	.text1 {
		margin-bottom: 5%;
	}
}
/* mobile */
@media (max-width: 640px) {
	.main-intro .contents {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		width: 100%;
		height: 100%;
	}
	.main-intro .p1 {
		position: relative;
		display: flex;
		align-items: center;
		width: 100%;
		height: 100%;
	}
	.main-intro .p2 {
		position: absolute;
		top: 0;
		left: 0;
		padding: 20% 0 0 5%;
	}
	.text1 .t1 {
		font-style: normal;
		font-weight: 300;
		font-size: 6.4vw;
		line-height: 10vw;
		color: #000000;
	}
	.text1 .t2 {
		font-style: normal;
		font-weight: bold;
		font-size: 6.4vw;
		line-height: 10vw;
		color: #000000;
	}
	.text1 .t2 span {
		font-style: normal;
		font-weight: bold;
		font-size: 6.4vw;
		line-height: 10vw;
		color: #000000;
		background: linear-gradient(to top, #007def 10%, transparent 10%);
	}
	.text2 {
		font-style: normal;
		font-weight: 300;
		font-size: 4.2vw;
		line-height: 6.5vw;
		color: #444444;
	}
	.text1 {
		margin-bottom: 5%;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/contents/intro/MainIntro.vue